const DIRS = [
  { k: "N", x: 0, y: -1 },
  { k: "NE", x: 0.7071, y: -0.7071 },
  { k: "E", x: 1, y: 0 },
  { k: "SE", x: 0.7071, y: 0.7071 },
  { k: "S", x: 0, y: 1 },
  { k: "SW", x: -0.7071, y: 0.7071 },
  { k: "W", x: -1, y: 0 },
  { k: "NW", x: -0.7071, y: -0.7071 },
];

const C = 60;
const R_LINE = 38;
const R_LABEL = 52;

export function Compass({ size = 116, value = null, onChange }) {
  const toggle = (k) => {
    if (!onChange) return;
    onChange(value === k ? null : k);
  };

  return (
    <svg viewBox="0 0 120 120" width={size} height={size} data-testid="compass" style={{ overflow: "visible" }}>
      {DIRS.map((d) => {
        const on = value === d.k;
        const color = on ? "var(--accent)" : "#5A5A5A";
        const x2 = C + d.x * R_LINE;
        const y2 = C + d.y * R_LINE;
        const lx = C + d.x * R_LABEL;
        const ly = C + d.y * R_LABEL;
        return (
          <g key={d.k} onClick={() => toggle(d.k)} style={{ cursor: onChange ? "pointer" : "default" }} data-testid={`compass-${d.k}`}>
            <line x1={C} y1={C} x2={x2} y2={y2} stroke="transparent" strokeWidth={14} />
            <line x1={C} y1={C} x2={x2} y2={y2} stroke={color} strokeWidth={2} />
            <text x={lx} y={ly} fill={color} fontSize={9} textAnchor="middle" dominantBaseline="central">
              {d.k}
            </text>
          </g>
        );
      })}
    </svg>
  );
}
